import { Alert, Collapse } from "@mui/material";
import { useBitacoraCotizacion } from "../hooks/useBitacoraCotizacion";
import { BitacoraCotizacionTimeline } from "./BitacoraCotizacionTimeline";
import type { BitacoraCotizacionProps } from "../types/bitacoraCotizacion.types";

export const BitacoraCotizacion = ({ id_cotizacion, folio }: BitacoraCotizacionProps) => {
    const { bitacora, folioRequisicion, procesando, isAlertOpen, mensajeAlert, handleisAlertClose } =
        useBitacoraCotizacion(id_cotizacion);

    return (
        <>
            <Collapse in={isAlertOpen}>
                <Alert severity="error" onClose={handleisAlertClose} sx={{ my: 2 }}>
                    {mensajeAlert}
                </Alert>
            </Collapse>
            <BitacoraCotizacionTimeline
                bitacora={bitacora}
                procesando={procesando}
                folio={folio}
                folioRequisicion={folioRequisicion}
            />
        </>
    );
};